import { lazy } from "react";
import { setStudioView } from "../workspace/studio-views";
import type { LivingRoomProps } from "./LivingRoom";
const LivingRoom = lazy(() => import("./LivingRoom").then(module => ({ default: module.LivingRoom })));

export function mountLivingRoom(slot: HTMLElement, props: LivingRoomProps) {
  setStudioView("drawer", "living-room", <LivingRoom key={`${props.projectId || "personal"}:${props.assetId}`} {...props} />);
}
